import { IConversations } from 'src/types/serviceResponseTypes';

/**
 * Mapper to add dummy message ID while in SME mode
 * BFB cannot send us ID, as in SME mode there isn't any real conversation happening
 */

export default function withSMEMapper(converations: IConversations) {
  return {
    ...converations,
    messages: converations.messages.map((previousMessage, index) => ({
      ...previousMessage,
      id: index,
      feedback: {
        ...previousMessage.feedback,
        messageId: index,
      },
    })),
  };
}
